import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, makeStyles } from '@material-ui/core';
import DateRangeWithTextField from './dateRangeWithTextField';
import CustomButton from '../customButton';
import { replaceObjectInList } from '../../../utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  label: {
    fontFamily: 'ProximaNova-Bold',
    fontSize: 20,
    lineHeight: '24px',
    marginBottom: spacing(4),
    marginRight: spacing(1),
  },
  divider: {
    '&::after': {
      content: '""',
      backgroundColor: primary.bluish5,
      display: 'block',
      marginBottom: spacing(6),
      marginTop: spacing(6),
      height: 1,
      width: '100%',
    },
    '&$hasError': {
      marginBottom: 0,
      '&::after': {
        content: '""',
        backgroundColor: primary.bluish5,
        display: 'block',
        marginBottom: spacing(6),
        marginTop: spacing(1),
        height: 1,
        width: '100%',
      },
    },
  },
}));

const DateRangeWithTextFields = ({
  translations,
  values = [],
  initialValues,
  fieldTypes,
  error = null,
  onChange,
  isDisabled = false,
  ...rest
}) => {
  const classes = useStyles();

  const handleAddField = useCallback(() => {
    return onChange([...values, { ...initialValues }]);
  }, [values, initialValues, onChange]);

  const handleDeleteValue = useCallback(
    fieldIndex => () => {
      const updatedValues = values.filter((val, index) => index !== fieldIndex);

      return onChange(updatedValues);
    },
    [values, onChange]
  );

  const handleChangeValue = useCallback(
    (field, fieldIndex) => {
      onChange(replaceObjectInList(values, fieldIndex, field));
    },
    [values, onChange]
  );

  return (
    <div>
      {translations.label && (
        <FormHelperText classes={{ root: classes.label }}>
          {translations.label}
        </FormHelperText>
      )}
      {values.map((val, index) => (
        <div key={`item_${index}`} className={classes.divider}>
          <DateRangeWithTextField
            id={index}
            translations={translations}
            value={val}
            isDisabled={isDisabled}
            fieldTypes={fieldTypes}
            error={error?.[index]}
            onDelete={handleDeleteValue(index)}
            onChange={handleChangeValue}
            {...rest}
          />
        </div>
      ))}
      <CustomButton
        disabled={isDisabled}
        type="addDarkRoundedOutlined"
        onClick={handleAddField}
      >
        {translations.addFieldButton}
      </CustomButton>
    </div>
  );
};

DateRangeWithTextFields.propTypes = {
  translations: PropTypes.object.isRequired,
  values: PropTypes.arrayOf(PropTypes.object),
  fieldTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  initialValues: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool,
  error: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default DateRangeWithTextFields;
